import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
      <DefaultInfoCard
      description="The HP Tech Solutions Privacy Policy explains how your information is collected and used and the choices you have with that information. You consent to Secure Support using your registration information and other information collected on this Site under the terms of the https://hptechsolutions.online/privacy-policy/"/>
          <DefaultInfoCard
                    title="What information do we collect?"
                    description="We analyze user behavior and needs to inform design decisions. Understanding the people we design for is essential in crafting seamless UI/UX experiences. Through in-depth user research, we dive deep into user behavior, motivations, and pain points. We conduct user interviews, surveys, and data analysis to capture valuable insights. This research allows us to design intuitive user interfaces (UI) and exceptional user experiences (UX) that are not only visually appealing but also meet real user needs and preferences"/>
          <DefaultInfoCard
                    title="What do we use your information for?"
                    description="Any of the information we collect from you may be used in one of the following ways:"/>
                       
                        
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="What We Do"
                    description="From advanced AI-powered applications to robust cybersecurity frameworks, from mobile and web development to data-driven digital marketing strategies—we offer a comprehensive range of services designed to drive innovation and ensure success."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="To process transactions"
                    description="Your information, whether public or private, will not be sold, exchanged, transferred, or given to any other company for any reason whatsoever, without your consent, other than for the express purpose of delivering the purchased product or service requested."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="To improve customer service"
                    description="your information helps us to more effectively respond to your customer service requests and support needs."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="To personalize your experience"
                    description="your information helps us to better respond to your individual needs"/>
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="To improve our services"
                    description="We continually strive to improve our service offerings based on the information and feedback we receive from you."
                  />
                </MKBox>
              </Grid>
              
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
